module.exports = __webpack_public_path__ + "static/no_auth.003b3ae3.png";